import React, { useEffect, useState } from 'react';
import { onlyNumber } from 'app/constants/regex';
import logger from 'app/utils/logger';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, useOutletContext, useSearchParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { green, red2, yellow } from 'app/components/ThemeProvider/colors';
import {
  useEmployeeSetStatus,
  useEmployeeUpsert,
  useGetEmployeeList,
  useGetProfile,
  useGetUserProfile,
} from 'app/utils/services/clientService';
import EditIcon from 'app/components/Icons/EditIcon';
import LockIcon from 'app/components/Icons/LockIcon';
import BinIcon from 'app/components/Icons/BinIcon';

const useClientProfilePage = () => {
  const [successModal, setSuccessModal] = useState(false);
  const [btnId, setBtnId] = useState(1);
  const [privateEmail, setPrivateEmail] = useState('');
  const [privateMobil, setPrivateMobil] = useState('');
  const [signType, setSignType] = useState<{ value: string; label: string }>();
  const [asanConfirmation, setAsanConfirmation] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [activeAnchor, setActiveAnchor] = useState('');
  const [employeeStatus, setEmployeeStatus] = useState('');
  const [employeeIdUser, setEmployeeIdUser] = useState('');

  const handleMenuClick = (event: any, status: any, id: any) => {
    setAnchorEl(event.currentTarget);
    setEmployeeStatus(status);
    setEmployeeIdUser(id);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (anchorEl !== null) {
      setActiveAnchor(anchorEl.getAttribute('aria-controls'));
    }
  }, [anchorEl]);

  const { control, register, handleSubmit, setValue, getValues } = useForm();

  const navigate = useNavigate();

  const location = useLocation();
  const lang = location.pathname.substring(0, 3);

  const [searchParams] = useSearchParams();
  const pageType = searchParams.get('type');
  const edit = searchParams.get('edit');

  const [statusBtnId, setStatusBtnId] = useState(1);
  const { companyId, userId, employeeId } = useOutletContext<{
    companyId: string;
    userId: string;
    employeeId: string;
  }>();
  const [employeeEditPage, setEmployeeEditPage] = useState(false);

  const { dataGetEmployeeList, isLoadingGetEmployeeList, refetchEmployeeList } = useGetEmployeeList();
  const { isLoadingGetUserProfile, dataGetUserProfile, getUserProfileMutation } = useGetUserProfile();
  const { isLoadingEmployeeSetStatus, employeeSetStatusMutation, dataEmployeeSetStatus } = useEmployeeSetStatus();
  const { isLoadingEmployeeUpsert, employeeUpsertMutation, dataEmployeeUpsert } = useEmployeeUpsert();
  const { getProfileMutation, dataGetProfile, isLoadingGetProfile } = useGetProfile();

  const details = [
    {
      value: 'edit',
      title: 'Düzəliş et',
      icon: <EditIcon sx={{ width: '18px', height: '18px' }} />,
    },
    {
      value: 'block',
      title: 'Bloklaşdırmaq',
      icon: <LockIcon color={'primary'} sx={{ width: '18px', height: '18px' }} />,
    },
    {
      value: 'unblock',
      title: 'Blokdan çıxar',
      icon: <LockIcon type="unlocked" color={'primary'} sx={{ width: '18px', height: '18px' }} />,
    },
    {
      value: 'delete',
      title: 'Sil',
      icon: <BinIcon sx={{ width: '18px', height: '18px' }} color={'warning'} />,
    },
  ];

  const filterBtns = [
    { id: 1, title: 'Şəxsi məlumatlar', route: 'information' },
    { id: 2, title: 'İstifadəçilər', route: 'users' },
  ];

  const statusFilterBtns = [
    {
      id: 1,
      title: 'Hamısı',
    },
    {
      id: 2,
      title: 'Aktiv',
      icon: <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: green }}></Box>,
    },
    {
      id: 3,
      title: 'Bloklaşdırılmış',
      icon: <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: yellow }}></Box>,
    },
  ];

  const options = [
    { value: 'asan', label: 'AZAN Imza' },
    { value: 'otp', label: 'OTP Imza' },
  ];

  const userStatus = [
    {
      value: 'active',
      label: 'Aktiv',
      icon: <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: green }}></Box>,
    },
    {
      value: 'blocked',
      label: 'Bloklaşdırılmış',
      icon: <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: yellow }}></Box>,
    },
    {
      value: 'closed',
      label: 'Bağlı',
      icon: <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: red2 }}></Box>,
    },
  ];

  const handleSend = (event: any) => {
    // setSuccessModal(true);
    getProfileMutation({
      action: 'sign',
      id: userId,
      employee_id: employeeId,
      form_id: 'profile',
      email: privateEmail,
      phone: privateMobil,
      // phone_otp: privateMobil,
      method: signType.value,
      // lname: getValues('lname'),
      // fname: getValues('fname'),
      // mname: getValues('mname'),
      // fin: getValues('fin'),
      // position_id: getValues('position'),
      // lang: 'az',
      // rules: {},
      // dataGetUserProfile?.user_profile.user_rules_arr,
      // status: dataGetUserProfile?.user_profile.companies.employee.status,
      // employee_id: dataGetUserProfile?.user_profile.companies.employee.id,
    });
  };

  useEffect(() => {
    if (dataGetUserProfile?.form_id === 'user_profile') {
      const selectedOption = options.filter(
        (item: any) => item.value === dataGetUserProfile?.user_profile.company.employee.method
      );
      setPrivateEmail(dataGetUserProfile?.user_profile.b2b_user.email);
      setPrivateMobil(dataGetUserProfile?.user_profile.b2b_user.phone);
      setValue('lname', dataGetUserProfile?.user_profile.b2b_user.lname);
      setValue('fname', dataGetUserProfile?.user_profile.b2b_user.fname);
      setValue('mname', dataGetUserProfile?.user_profile.b2b_user.mname);
      setValue('fin', dataGetUserProfile?.user_profile.b2b_user.fin);
      setValue('position', dataGetUserProfile?.user_profile.company.employee.position_title);
      setSignType(selectedOption[0]);
    }
  }, [dataGetUserProfile]);

  useEffect(() => {
    if (dataEmployeeUpsert?.form_id === 'employee_upsert') {
      navigate(`${lang}/profile?edit=true`);
    }
  }, [dataEmployeeUpsert]);

  useEffect(() => {
    if (pageType === 'information') {
      getUserProfileMutation(employeeId);
      setBtnId(1);
    } else if (pageType === 'users') {
      setBtnId(2);
      // getEmployeeListMutation();
      refetchEmployeeList();
    }
  }, [pageType]);

  const handleChangeEmail = (e: any) => {
    const inputValue = e.target.value;

    setPrivateEmail(inputValue);
  };

  const handleChangePhone = (e: any) => {
    const inputValue = e.target.value;

    setPrivateMobil(inputValue);
  };

  const handleChangeSignType = (newValue: any) => {
    setSignType(newValue);
  };

  const handleChangePageType = (id: number) => {
    setBtnId(id);
    navigate(`${lang}/profile?type=${filterBtns[id - 1].route}`);

    // if (id === 1) {
    //   getUserProfileMutation(userId);
    // }
    //
    // if (id === 2) {
    //   getEmployeeListMutation(companyId);
    // }
  };

  const handleClickMenuUsers = (value: any, id: any) => {
    logger.log('value');
    logger.log(value);
    logger.log(id);

    if (value === 'edit') {
      employeeUpsertMutation({
        businessKey: dataGetEmployeeList?.business_key,
        data: {
          action: 'edit',
          employee_id: id,
        },
      });
    }

    if (value === 'block') {
      employeeSetStatusMutation({
        employee_id: id,
        status: 'blocked',
      });
    }

    if (value === 'unblock') {
      employeeSetStatusMutation({
        employee_id: id,
        status: 'active',
      });
    }

    if (value === 'delete') {
      employeeSetStatusMutation({
        employee_id: id,
        status: 'delete',
      });
    }

    setAnchorEl(null);
  };

  const handleEmployeeAdd = () => {
    navigate(`${lang}/add-employee`, { state: { businessKey: dataGetEmployeeList?.business_key } });
  };

  return {
    options,
    edit,
    successModal,
    setSuccessModal,
    handleSend,
    control,
    register,
    filterBtns,
    btnId,
    setBtnId,
    handleChangePageType,
    pageType,
    statusFilterBtns,
    statusBtnId,
    setStatusBtnId,
    handleEmployeeAdd,
    isLoadingGetEmployeeList,
    isLoadingGetUserProfile,
    dataGetUserProfile,
    dataGetEmployeeList,
    userStatus,
    privateMobil,
    privateEmail,
    handleChangeEmail,
    handleChangePhone,
    handleChangeSignType,
    signType,
    details,
    handleClickMenuUsers,
    asanConfirmation,
    setAsanConfirmation,
    dataEmployeeUpsert,
    employeeStatus,
    anchorEl,
    activeAnchor,
    handleClose,
    handleMenuClick,
    employeeIdUser,
  };
};

export default useClientProfilePage;
